import {Component, Input, OnInit} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.scss']
})
export class ConfigurationsComponent implements OnInit {

  constructor(public platform: LeftpanelComponent) { }
  @Input() partner: any;
  @Input() account: any;
  @Input() service: any;
  @Input() id: any;
  @Input() configuration: any;
  @Input() environment: any;
  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
  }

}
// partner
// account
// environment
// service
// configurations
